import { render } from "./YouPage.vue?vue&type=template&id=1984e996&scoped=true"
import script from "./YouPage.vue?vue&type=script&lang=js"
export * from "./YouPage.vue?vue&type=script&lang=js"

import "./YouPage.vue?vue&type=style&index=0&id=1984e996&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1984e996"]])

export default __exports__